//http://momentjs.cn/docs/
import moment from "moment";
//设定moment区域为中国
import "moment/locale/zh-cn";
moment.locale("zh-cn");
/**日期格式相关的处理 */
export default class datetimeUtils {
  constructor() {}
  static stringToDate(dateStr) {
    return moment(dateStr).toDate();
  }
  static pad2(n) {
    return n < 10 ? "0" + n : n;
  }
  /**
   * 获取前N天的日期
   * @param days 时间间隔天数
   * @returns {string}
   */
  static getPreDate(days, d) {
    if (d) {
      return moment(d).subtract(days, "days").toDate();
    } else {
      return moment().subtract(days, "days").toDate();
    }
  }
  /**
   * 获取当前时间后N天的日期
   * @param days 时间间隔天数
   * @returns {Date}
   */
  static getNextDate(days) {
    return moment().add(days, "days").toDate();
  }
  static getTimeByFormatStr(d, f) {
    return moment(d).format(f);
  }
   /**
   * 获取指定时间时分
   */
 static getAssignTimeHourMin(d) {
  return moment(d).format('HH:mm');
}
  /**
   * 获取特定日期后N天的日期
   * @param days 时间间隔天数
   * @returns {Date}
   */
  static getDateNextDate(d, days) {
    return moment(d).add(days, "days").toDate();
  }
   /**
   * 获取指定时间时分
   */
 static getAssignTimeHourMin(d) {
  return moment(d).format('HH:mm');
}
  /**
   * 获取特定日期后N秒的日期时间
   * @param second
   * @returns {Date}
   */
  static getDateTimeNextSecond(d, second) {
    return moment(d).add(second, "s").toDate();
  }
  /**
   * 获取指定日期后m分钟
   * @param {*} d
   * @param {*} m
   */
  static getTimeNextTime(d, m) {
    return moment(d).add(m, "m").format("HH:mm:ss");
  }
  /**
   * 获取当前日期前n个月
   * @returns {Date}
   */
  static getBeforeMonth(val) {
    return moment().subtract(val, "M").toDate();
  }
  /**
   * 获取制定日期前n分钟
   * @returns {Date}
   */
  static getBeforeMinute(d, m) {
    return moment(d).subtract(m, "m").format("YYYY-MM-DD HH:mm:ss");
  }
  /**
   * 获取指定日期前n个月
   * @param {*} d
   * @param {*} val
   */
  static getBeforeMonthByDate(d, val) {
    return moment(d).subtract(val, "M").toDate();
  }
  /**
   * 获取指定日期后n个月
   * @param {*} d
   * @param {*} val
   */
  static getAfterMonthByDate(d, val) {
    return moment(d).add(val, "M").toDate();
  }
  /**
   * 获取特定日期，特定格式的日期  yyyy,mm,dd
   * @returns {string}
   */
  static getSpecialDay(date, seperator = "-") {
    if (!date) {
      return "";
    }
    // let d = moment(date).format('YYYY' + seperator + 'MM' + seperator + 'DD');
    return moment(date).format("YYYY" + seperator + "MM" + seperator + "DD");
  }

  /**
   * 获取时间  yyyy-mm-dd hh:mm:ss  日期转字符串
   * @returns {string}
   */
  static getformatDateTime(d, seperator = "-") {
    return moment(d).format(
      "YYYY" + seperator + "MM" + seperator + "DD" + " HH:mm:ss"
    );
  }
  /**
   * 获取时间  yyyy-mm-dd hh:mm:ss  日期转字符串
   * @returns {string}
   */
  static getformatDateTimeByStr(d, str, seperator = "-") {
    return moment(d, str).format(
      "YYYY" + seperator + "MM" + seperator + "DD" + " HH:mm:ss"
    );
  }
  /**
   * 获取时分
   * @returns
   */
  static getDivisionTime(d) {
    return moment(d).format("HH:mm");
  }
  /**
   * 获取当前时分秒
   */
  static getCurShortTime() {
    return moment().format("HH:mm:ss");
  }
  /**
   * 根据格式获取指定时间
   */
  static getTimeByFormat(d, format) {
    return moment(d).format(format);
  }
  /**
   * 根据日期获取年份
   * @param {} d
   */
  static getYearByDate(d) {
    return moment(d).format("YYYY");
  }
  /**
   * 根据日期获取年和月
   * @param {} d
   */
  static getYearMonthByDate(d) {
    return moment(d).format("YYYY-MM");
  }
  /**
   * 获取当前年月日
   */
  static getCurYmdTime() {
    return moment().format("YYYY-MM-DD");
  }
  /**
   * 获取指定时间年月日
   */
  static getSpecialYmdTime(d) {
    return moment(d).format("YYYY-MM-DD");
  }
  /**
   * 获取当前时分
   */
  static getHourMin() {
    return moment().format("HH:mm");
  }
   /**
   * 获取指定时间日
   */
   static getSpecialdTime(d) {
    return moment(d).format('DD');
  }
  /**
   * 获取当前年月日时分
   */
  static getCurYmdhmTime() {
    return moment().format("YYYY-MM-DD HH:mm");
  }
  /**
   * 获取当前年月日时分秒
   */
  static getCurYmdshmTime() {
    return moment().format("YYYY-MM-DD HH:mm:ss");
  }
  //获取指定日期的开始时间
  static getStartTime(d) {
    return moment(moment(d).format("YYYY-MM-DD") + " 00:00:00").toDate();
  }
  //获取指定日期的截止时间
  static getEndTime(d) {
    return moment(moment(d).format("YYYY-MM-DD") + " 23:59:59").toDate();
  }
  //获取指定日期的开始时间
  static getStartTimeStr(d) {
    return moment(d).format("YYYY-MM-DD") + " 00:00:00";
  }
  //获取指定日期的截止时间
  static getEndTimeStr(d) {
    return moment(d).format("YYYY-MM-DD") + " 23:59:59";
  }
  //获取指定日期的时间
  static getTansTime(d) {
    return moment(d).format("YYYY-MM-DD HH:mm:ss");
  }
  //获取指定日期的时间 -- 查询到分钟
  static getminTime(d) {
    return moment(d).format("YYYY-MM-DD HH:mm") + ":00";
  }
  //获取指定日期的时间 -- 查询到小时
  static getHoursTime(d) {
    return moment(d).format("YYYY-MM-DD HH") + ":00:00";
  }
  //获取指定日期的时间 -- 查询到小时不添加时分
  static getHoursDate(d) {
    return moment(d).format("YYYY-MM-DD HH");
  }
  /**
   * 获取几天前，拼接 yyyy-mm-dd hh:mm:ss
   * todo 用于界面日期时间选择规则-结束时间
   */
  static getTodayCurBeforeEndDate(i) {
    const date = new Date(new Date().getTime() - 1000 * 60 * 60 * 24 * i);
    const year = date.getFullYear();
    let month = date.getMonth() + 1;
    month = month > 9 ? month : "0" + month;
    let day = date.getDate();
    day = day > 9 ? day : "0" + day;
    // let hour = date.getHours();
    // hour = hour > 9 ? hour : '0' + hour;
    // let minute = date.getMinutes();
    // minute = minute > 9 ? minute : '0' + minute;
    // let second = date.getSeconds();
    // second = second > 9 ? second : '0' + second;
    return year + "-" + month + "-" + day + ` 00:00:00`;
  }

  //时间格式转换
  static GMTToStr(time) {
    let date = new Date(time);
    let Str =
      date.getFullYear() +
      "-" +
      (date.getMonth() + 1) +
      "-" +
      date.getDate() +
      " " +
      date.getHours() +
      ":" +
      date.getMinutes() +
      ":" +
      date.getSeconds();
    return Str;
  }
  static GMTToStrRorType(time, type) {
    let date = new Date(time);
    let Str = "";
    if (type == "year") {
      Str = date.getFullYear() + "年";
    } else if (type == "month") {
      Str = date.getFullYear() + "年" + (date.getMonth() + 1) + "月";
    } else if (type == "day") {
      Str =
        date.getFullYear() +
        "年" +
        (date.getMonth() + 1) +
        "月" +
        date.getDate() +
        "日";
    } else {
      Str =
        date.getFullYear() +
        "-" +
        (date.getMonth() + 1) +
        "-" +
        date.getDate() +
        " " +
        date.getHours() +
        ":" +
        date.getMinutes() +
        ":" +
        date.getSeconds();
    }
    return Str;
  }
  //获取指定日期有多少天
  static getMonthLength(d) {
    // 将日期设置为下月一号
    d.setMonth(d.getMonth() + 1);
    d.setDate("1");
    // 获取本月最后一天
    d.setDate(d.getDate() - 1);
    return d.getDate();
  }
  /**
   * 获取指定日期当月所有的星期
   * @param {*} d
   * @param {*} days
   */
  static getMonthWeek(d, days) {
    let year = d.getFullYear();
    let month = d.getMonth();
    let weeks = [];
    for (var i = 1; i <= days; i++) {
      weeks.push(datetimeUtils.getWeek(year, month, i));
    }
    return weeks;
  }
  /**
   * 根据日期获取星期
   * @param {*} y ：年
   * @param {*} m ：月
   * @param {*} d ：日
   */
  static getWeek(y, m, d) {
    var myDate = new Date();
    myDate.setFullYear(y, m, d);
    var week = myDate.getDay();
    switch (week) {
      case 0:
        return "周日";
      case 1:
        return "周一";
      case 2:
        return "周二";
      case 3:
        return "周三";
      case 4:
        return "周四";
      case 5:
        return "周五";
      case 6:
        return "周六";
    }
  }
  //获取当前年月
  static getCurYearMonth() {
    return moment().format("YYYY-MM");
  }
  //获取当前年月日
  static getCurYearMonthDay() {
    return moment().format("YYYY-MM-DD");
  }
  //获取指定日期所在月份第一天日期
  static getCurYearMonthFirstDay(d) {
    return moment(d).format("YYYY-MM") + "-01" + " 00:00:00";
  }
  //获取当月最后一天 yyyy-mm-dd 23:59:59
  static newForMatToDateOfMonthLastDay(dateString) {
    let date = new Date(dateString);
    //下一个月的第一天 -- 一天  =  当前月最后一天
    let year = date.getFullYear(),
      month = date.getMonth() + 1;
    let lastDay;
    if (month + 1 > 12) {
      // 跨年
      lastDay = new Date(
        new Date(year + 1 + "-" + 1).getTime() - 86400 * 1000
      ).getDate();
    } else {
      lastDay = new Date(
        new Date(year + "-" + (month + 1)).getTime() - 86400 * 1000
      ).getDate();
    }
    month = month < 10 ? "0" + month : month;
    return year + "-" + month + "-" + lastDay + " 23:59:59";
  }
  /**
   * 获取指定日期年月
   * @param {*} d
   * return {String}
   */
  static getYearMonthByDate(d) {
    return moment(d).format("YYYY-MM");
  }
  /**
   * 获取指定日期年月日
   * @param {*} d
   * return {String}
   */
  static getYearMonthDayByDate(d) {
    return moment(d).format("YYYY-MM-DD");
  }
  //获取指定日期当月最后一天
  static getDateMonthLastDay(d) {
    return moment(d).endOf("month").toDate();
  }
  //获取指定日期当月最后一天
  static getDateMonthLastDayStr(d) {
    return moment(d).endOf("month").format("YYYY-MM-DD") + " 23:59:59";
  }
  // 获取指定日期当月最后一天 YYYY-MM-DD
  static getDateMonthLastDayDD(d) {
    return moment(d).endOf("month").format("YYYY-MM-DD");
  }
  //获取指定多少天内
  static WithinTheSpecifiedDate(startTime, endTime, day) {
    let gap = endTime.getTime() - startTime.getTime();
    let time = 86400 * 1000 * day;
    if (gap > time) {
      return false;
    } else {
      return true;
    }
  }
  //获取当月最后一天
  static getday(month) {
    switch (month) {
      case "2":
        return 28;
        break;
      case "1":
      case "3":
      case "5":
      case "7":
      case "8":
      case "10":
      case "12":
        return 31;
        break;
      default:
        return 30;
    }
  }
  /**
   * 获取今天的日期 -前一个小时的59分59秒，拼接 yyyy-mm-dd hh:mm:ss
   * todo 用于界面日期时间选择规则-结束时间
   */
  static newGetTodayCurEndDate() {
    let date = new Date(new Date().getTime() - 1000 * 60 * 60);
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    month = month > 9 ? month : "0" + month;
    let day = date.getDate();
    day = day > 9 ? day : "0" + day;
    let hour = date.getHours();
    hour = hour > 9 ? hour : "0" + hour;
    return year + "-" + month + "-" + day + ` ${hour}:59:59`;
  }
  /**
   * 计算时间差，返回相差的分钟数
   * @param {*} t1 某天的时间
   * @param {*} t2 后一天的时间
   * @param {*} diffVal
   */
  static diffTime(t1, t2, diffVal = 0) {
    // debugger;
    let time1 = moment(t1, "hh:mm").add(diffVal, "m");
    let time2 = moment(t2, "hh:mm").add(1, "d");
    let res = time2.diff(time1, "minute"); //计算相差的分钟数
    return res;
  }
  /**
   * 计算今天两个时间的时间差
   * @param {*} t1 起始时间
   * @param {*} t2 截止时间
   */
  static toDayDiffTime(t1, t2) {
    const time1 = moment(t1, "hh:mm");
    const time2 = moment(t2, "hh:mm");
    const res = time2.diff(time1, "minute"); //计算相差的分钟数
    return res;
  }
  /**
   *自定义根据时间粒度类型初始化时间值(month:n个月前）
   * @param json
   * @param hms 后缀：时分秒
   * @param month ：当粒度为月份时，取近month个月的数据
   */
  static newInitSearchDateValueSelf(json, hms, month, type) {
    console.log(type, 454545);
    var suffix = hms ? " 00:00:00" : "";
    //根据时间粒度类型初始化时间值
    if (json.dateTypeId === 1 || json.dateTypeId === 7) {
      //时
      json.startDateValue =
        type == "carbon"
          ? datetimeUtils.getSpecialYmdTime(datetimeUtils.getPreDate(7)) +
            " 00:00:00"
          : datetimeUtils.getSpecialYmdTime(datetimeUtils.getPreDate(10)) +
            " 00:00:00";
      json.endDateValue =
        datetimeUtils.getSpecialYmdTime(
          new Date().getTime() - 60 * 60 * 1000 * 24
        ) + " 23:59:59";
      json.dateOptions.format = "yyyy-MM-dd HH";
    } else if (json.dateTypeId === 2) {
      //日  yyyy-mm-dd
      json.startDateValue =
        datetimeUtils.getSpecialYmdTime(datetimeUtils.getPreDate(31 + 1)) +
        " 00:00:00";
      //yyyy-mm-dd 23:59:59
      json.endDateValue =
        datetimeUtils.getSpecialYmdTime(datetimeUtils.getPreDate(1)) +
        " 23:59:59";
      json.dateOptions.format = "yyyy-MM-dd";
    } else if (json.dateTypeId === 4) {
      //月
      json.dateOptions.format = "yyyy-MM";
      json.startDateValue =
        new Date().getFullYear() -
        1 +
        "-" +
        (new Date().getMonth() + 1 >= 10
          ? new Date().getMonth() + 1
          : "0" + (new Date().getMonth() + 1)) +
        "-01 00:00:00";
      // json.endDateValue =
      //   new Date().getFullYear() +
      //   "-" +
      //   (new Date().getMonth() + 1 >= 10
      //     ? new Date().getMonth() + 1
      //     : "0" + (new Date().getMonth() + 1)) +
      //   "-" +
      //   datetimeUtils.getday(new Date().getMonth() + 1) +
      //   " 23:59:59";
      json.endDateValue =datetimeUtils.getDateMonthLastDayStr(datetimeUtils.getBeforeMonth(1)) 
            console.log(json.endDateValue,'json.endDateValue');
      if (json.valueFormat) {
        json.valueFormat = "yyyy-MM";
      }
    } else if (json.dateTypeId == 5) {
      //年
      //yyyy-mm-dd 23:59:59
      //json.startDateValue = '2008-01-01' + "  00:00:00";
      json.startDateValue =
        new Date().getFullYear() - 10 + "-" + "01" + "-" + "01" + " 00:00:00";
      json.endDateValue =
        new Date().getFullYear() +
        "-" +
        "12-" +
        datetimeUtils.getday("12") +
        " 23:59:59";
      json.dateOptions.format = "yyyy";
    } else if (json.dateTypeId == 3) {
      json.dateOptions.format = "yyyy 第 WW 周";
      json.startDateValue =
        datetimeUtils.getSpecialYmdTime(datetimeUtils.getPreDate(14)) +
        " 00:00:00";
      json.endDateValue = datetimeUtils.getStandartDay("-") + " 23:59:59";
    } else {
      json.startDateValue =
        datetimeUtils.getSpecialYmdTime(datetimeUtils.getPreDate(3)) +
        " 00:00:00";
      json.endDateValue = datetimeUtils.newGetTodayCurEndDate();
      json.dateOptions.format = "yyyy-MM-dd HH";
    }
    if (json.dateOptions.startDateValue) {
      json.dateOptions.startDateValue = json.startDateValue;
    }
    if (json.dateOptions.endDateValue) {
      json.dateOptions.endDateValue = json.endDateValue;
    }
  }

  //获取查询的开始时间
  static getSearchStartTime(res, hms) {
    var startDateValue = "";
    var suffix = hms ? " 00:00:00" : "";
    if (!res.startDateValue) {
      startDateValue = "";
    } else if (res.startDateValue.length == 4) {
      startDateValue = res.startDateValue + "-01-01" + suffix;
    } else if (res.startDateValue.length < 8) {
      startDateValue = res.startDateValue + "-01" + suffix;
    } else if (res.startDateValue.length < 12) {
      startDateValue = res.startDateValue + suffix;
    } else {
      startDateValue = res.startDateValue;
    }
    return startDateValue;
  }

  //获取查询的结束时间
  static getSearchEndTime(res, hms) {
    var endDateValue = "";
    var suffix = hms ? " 00:00:00" : "";
    if (!res.endDateValue) {
      endDateValue = "";
    } else if (res.endDateValue.length == 4) {
      var month = new Date().getMonth() + 1;
      var monthStr = month < 10 ? "-0" + month : "-" + month;
      endDateValue = res.endDateValue + monthStr + "-01" + suffix;
    } else if (res.endDateValue.length < 8) {
      //月
      // endDateValue = res.endDateValue + "-01" + suffix;
      endDateValue=datetimeUtils.getDateMonthLastDayStr(res.endDateValue);

      // let val = res.endDateValue + "-01"+suffix;
      // endDateValue=GlobalUtil.getDateOfMonthLastDay(val,suffix);
    } else if (res.endDateValue.length < 12) {
      endDateValue = res.endDateValue + suffix;
    } else {
      endDateValue = res.endDateValue;
    }
    return endDateValue;
  }
}
